import { ISubsidy } from '../../../interfaces/Subsidy.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetSubsidyByIdParams {
  subsidyId: string;
}

export const getSubsidyById = ({ subsidyId }: IGetSubsidyByIdParams): Promise<ISubsidy> => {
  return customAxios.get(`/subsidies/${subsidyId}`);
};
